import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { ThemeService } from "src/app/services/themes.service";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-redirect-to-login',
    templateUrl: './redirect-to-login.component.html',
    styleUrls: ['./redirect-to-login.component.scss'],
})

export class RedirectToLoginComponent implements OnInit {

    themedata: any;
    fontdata: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<RedirectToLoginComponent>,
        private router: Router,
        private themeService: ThemeService,
        private cookieService: CookieService,
    ) { }

    ngOnInit(): void {
        this.themeService.theme$.subscribe((response) => {
            this.themedata = response;
        });

        this.themeService.selectedFont$.subscribe((response) => {
            this.fontdata = response;
        });
    }

    navigateToLoginPage() {
        this.cookieService.delete('vmanico-session-id');
        this.router.navigate(['/', 'auth', 'login']);
        this.onClose();
    }

    onClose() {
        this.dialogRef.close();
    }
}